import React, { memo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import AlertCDS from './AlertCDS';
import { wrapperStyles } from './AlertsCDS.styles';

const defaultArray = [];

const AlertsCDS = ({ messages = defaultArray, onClose }) => {
  return (
    <Box sx={wrapperStyles}>
      {messages.map(options => (
        <AlertCDS key={options.id} {...options} onClose={onClose} />
      ))}
    </Box>
  );
};

AlertsCDS.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
        .isRequired,
      variant: PropTypes.string,
      title: PropTypes.string,
      withCloseButton: PropTypes.bool,
      actions: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
          onClick: PropTypes.func,
        }),
      ),
    }),
  ),
  onClose: PropTypes.func,
};

export default memo(AlertsCDS);
